import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { SEOService } from '../../core/services/seo-service/seo.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PersonalSiteService } from './personal-site.service';
import { FindUserByNicknevResponseDto } from './personal-site.interfaces';
import { EnvironmentVariablesService } from '../../core/services/environment-variable-service/environment-variables.service';
import { ExposedEnvironmentVariable } from '../../../environments/environment-variables';
import { LandingPageService } from '../landing-pages/landing-page.service';
import { MobilePackageDetails } from '../../shared/components/large-mobile-package/large-mobile-package.interfaces';
import { isPlatformBrowser } from '@angular/common';
import { MobileServicesService } from '../mobile-services/mobile-services.service';
import { IMobileServiceResolverData } from '../mobile-services/mobile-services.interface';

@Component({
  selector: 'app-personal-site',
  templateUrl: './personal-site.component.html',
  styleUrls: ['./personal-site.component.scss'],
})
export class PersonalSiteComponent implements OnInit {
  nicknev: string;
  user: FindUserByNicknevResponseDto;
  allServicesData: IMobileServiceResolverData;
  isLoading = false;
  isVeaShop: boolean;

  constructor(
    private seoService: SEOService,
    private route: ActivatedRoute,
    private router: Router,
    private personalSiteService: PersonalSiteService,
    private environmentVariablesService: EnvironmentVariablesService,
    private landingPageService: LandingPageService,
    private mobileServicesService: MobileServicesService,
    private activatedRoute: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.nicknev = this.route.snapshot.paramMap.get('username').trim().toLocaleLowerCase();
    this.user = { ...this.activatedRoute.snapshot.data.user, nicknev: this.nicknev };
    this.allServicesData = { ...this.activatedRoute.snapshot.data.services };
    this.isVeaShop =
      this.user.keycloakRealm === this.environmentVariablesService.getVar(ExposedEnvironmentVariable.KEYCLOAK_REALM);
    this.isLoading = false;
    if (isPlatformBrowser(this.platformId)) {
      this.landingPageService.setRecommender(this.user);
    }
  }

  orderPackage(packageItem: MobilePackageDetails): void {
    this.mobileServicesService.findMobileServiceByCrmId(+packageItem.crmIdentifier).then((result) => {
      this.mobileServicesService.updateOrderObjectWithSelectedMobileService(result);
    });
  }
}
